"use strict";

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = useLatestUpdate;

var _react = require("react");

var _UpdateTracker = _interopRequireDefault(require("../UpdateTracker"));
/**
 * Hook that subscribes to updates on the given resources,
 * returning the latest update as `{ timestamp, url }`.
 */


function useLatestUpdate() {
  for (var _len = arguments.length, urls = new Array(_len), _key = 0; _key < _len; _key++) {
    urls[_key] = arguments[_key];
  }

  var _ref = (0, _react.useState)({}),
      _ref2 = _slicedToArray(_ref, 2),
      latestUpdate = _ref2[0],
      setLatestUpdate = _ref2[1];

  (0, _react.useDebugValue)(latestUpdate.timestamp || null);
  (0, _react.useEffect)(function () {
    var tracker = new _UpdateTracker.default(setLatestUpdate);
    tracker.subscribe.apply(tracker, urls);
    return function () {
      return tracker.unsubscribe.apply(tracker, urls);
    };
  }, urls);
  return latestUpdate;
}